import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "grid grid-cols-4 border rounded-lg" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col p-4 row-span-2 space-y-2 border-r"
}
const _hoisted_3 = {
  key: 0,
  class: "flex justify-start max-w-max"
}
const _hoisted_4 = {
  key: 1,
  class: "font-semibold text-24px text-black-lp-300"
}
const _hoisted_5 = {
  key: 1,
  class: "grid grid-cols-3 col-span-3 ml-4"
}
const _hoisted_6 = {
  key: 0,
  class: "flex flex-row justify-between space-x-3 items-center"
}
const _hoisted_7 = { class: "text-red-lp-100 text-14px" }
const _hoisted_8 = { class: "h-full items-center flex" }
const _hoisted_9 = { class: "flex flex-col justify-start w-full space-y-1" }
const _hoisted_10 = {
  key: 0,
  class: "flex justify-start max-w-max"
}
const _hoisted_11 = {
  key: 1,
  class: "font-semibold text-20px text-black-lp-300"
}
const _hoisted_12 = { class: "h-full w-full max-w-max flex justify-end" }
const _hoisted_13 = { class: "flex flex-col justify-start space-y-1" }
const _hoisted_14 = /*#__PURE__*/_createVNode("hr", { class: "bg-gray-lp-600" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_TooltipV2 = _resolveComponent("TooltipV2")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_LpButton = _resolveComponent("LpButton")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.data.length)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", {
            class: 
          `${
            _ctx.sttData(true).totalStt ? _ctx.styles.backgroundColor : 'bg-gray-lp-700'
          } rounded-md p-3 flex max-w-max mb-2`
        
          }, [
            _createVNode(_component_Icons, {
              name: _ctx.sttData(true).icon,
              class: 
            `${
              _ctx.sttData(true).totalStt ? _ctx.styles.iconColor : 'text-gray-lp-600'
            } h-5`
          
            }, null, 8, ["name", "class"])
          ], 2),
          _createVNode(_component_TooltipV2, {
            text: _ctx.$t(_ctx.sttData(true).title),
            description: _ctx.$t(_ctx.sttData(true).description)
          }, null, 8, ["text", "description"]),
          (_ctx.sttData(true).loading)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode(_component_Spinner, {
                  class: "loader",
                  style: {"height":"30px"},
                  color: "#EBECF0"
                })
              ]))
            : (_openBlock(), _createBlock("p", _hoisted_4, _toDisplayString(_ctx.formatDecimal(_ctx.sttData(true).totalStt)), 1))
        ]))
      : _createCommentVNode("", true),
    (_ctx.data.length)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sttData(false), (e, i) => {
            return (_openBlock(), _createBlock("div", {
              key: i,
              class: 
            `p-4 flex flex-row space-x-3 w-full
             ${Number(i) < (_ctx.data.length > 7 ? 6 : 3) ? 'border-b' : ''} ${
              Number(i) % 3 === 2 ? '' : 'border-r'
            }`
          
            }, [
              (e.error && !e.loading)
                ? (_openBlock(), _createBlock("div", _hoisted_6, [
                    _createVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("dashboard.console.allStt.failedToLoad")) + " " + _toDisplayString(_ctx.$t(e.title)), 1),
                    _createVNode(_component_LpButton, {
                      iconV2: "",
                      iconLeft: "reload",
                      textSize: 12,
                      textColor: "red-lp-100",
                      color: "red-lp-100",
                      outline: "",
                      small: "",
                      onClick: () => _ctx.fetchConsoleData(e)
                    }, null, 8, ["onClick"])
                  ]))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _createVNode("div", _hoisted_8, [
                      _createVNode("div", {
                        class: 
                  `${
                    e.totalStt ? _ctx.styles.backgroundColor : 'bg-gray-lp-700'
                  } rounded-md p-3 flex max-w-max`
                
                      }, [
                        _createVNode(_component_Icons, {
                          name: e.icon,
                          class: 
                    `${e.totalStt ? _ctx.styles.iconColor : 'text-gray-lp-600'} h-5`
                  
                        }, null, 8, ["name", "class"])
                      ], 2)
                    ]),
                    _createVNode("div", _hoisted_9, [
                      _createVNode(_component_TooltipV2, {
                        text: _ctx.$t(e.title),
                        description: _ctx.$t(e.description)
                      }, null, 8, ["text", "description"]),
                      (e.loading)
                        ? (_openBlock(), _createBlock("div", _hoisted_10, [
                            _createVNode(_component_Spinner, {
                              class: "loader",
                              style: {"height":"30px"},
                              color: "#EBECF0"
                            })
                          ]))
                        : (_openBlock(), _createBlock("p", _hoisted_11, _toDisplayString(_ctx.formatDecimal(e.totalStt)), 1))
                    ]),
                    _createVNode("div", _hoisted_12, [
                      _createVNode(_component_TooltipV2, {
                        icon: "ellipsis",
                        width: "180",
                        disabled: !e.totalStt
                      }, {
                        default: _withCtx((tooltip) => [
                          _createVNode("div", _hoisted_13, [
                            _createVNode(_component_LpButton, {
                              title: _ctx.$t('dashboard.console.common.viewDetail'),
                              iconV2: "",
                              iconLeft: "file-chart",
                              textColor: "black-lp-300",
                              textSize: 14,
                              flat: "",
                              dense: "",
                              onClick: ($event: any) => (_ctx.toDetail(e, tooltip))
                            }, null, 8, ["title", "onClick"]),
                            _hoisted_14,
                            _createVNode(_component_LpButton, {
                              title: _ctx.$t('dashboard.console.common.downloadXlsx'),
                              iconV2: "",
                              iconLeft: "file-download",
                              textColor: "black-lp-300",
                              textSize: 14,
                              flat: "",
                              dense: "",
                              onClick: ($event: any) => (_ctx.toDownload(e, tooltip))
                            }, null, 8, ["title", "onClick"])
                          ])
                        ]),
                        _: 2
                      }, 1032, ["disabled"])
                    ])
                  ], 64))
            ], 2))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}